<template>
  <section>
    <b-field label="Naam">
      <b-input placeholder="Naam" type="name"></b-input>
    </b-field>

    <b-field label="Email adress">
      <b-input placeholder="Email" type="email"></b-input>
    </b-field>

    <b-field label="Message">
      <b-input maxlength="200" type="textarea"></b-input>
    </b-field>
    <b-field>
      <p class="control">
        <button class="button is-primary">Send message</button>
      </p>
    </b-field>
  </section>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Help.vue